<template lang="pug">
  b-modal#teamLogInfo(
  ref="teamLogInfoModal"
  :title="$t('ui.team_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="xl"
  :busy="loading"
  @shown="shown")
    div(v-if="detail")
      div(v-if="filteredOldDetailList.length > 0")
        b-form-group(:label="$t('ui.old')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $t("ui.name") }}
                    th(width=100)
                      span {{ $t("ui.sbo") }}
                    th(width=100)
                      span {{ $t("ui.ibc") }}
                    th(width=100)
                      span {{ $t("ui.prefer") }}
                    th(width=60)
                      span {{ $t("ui.linked") }}
                    th(width=40).text-center
                      span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                    th(width=150)
                      span(v-if="page == 'team'") {{ $t("ui.add_team_provider") }}
                      span(v-if="page == 'mapteam'") {{ $t("ui.prefer_provider") }}
                      span(v-if="page == 'purgeteam'") {{ $t("ui.input_team_id") }}
                tbody
                  tr(v-for="item in filteredOldDetailList")
                    td
                      span {{ item.team_id }}
                    td
                      span {{ getSportType(item.sport_id) }}
                    td
                      span(:title="item.team_name") {{ item.team_name }}
                    td
                      span {{ item.sbo_map }}
                    td
                      span {{ item.ibc_map }}
                    td
                      span {{ item.prefer_id }}
                    td
                      span {{ item.link_id }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                    td
                      span(v-if="page == 'team'") {{ item.add_team_provider }}
                      span(v-if="page == 'mapteam'") {{ item.prefer_provider }}
                      span(v-if="page == 'purgeteam'") {{ item.input_team_id }}
      div(v-if="filteredNewDetailList.length > 0")
        b-form-group(:label="$t('ui.new')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $t("ui.name") }}
                    th(width=100)
                      span {{ $t("ui.sbo") }}
                    th(width=100)
                      span {{ $t("ui.ibc") }}
                    th(width=100)
                      span {{ $t("ui.prefer") }}
                    th(width=60)
                      span {{ $t("ui.linked") }}
                    th(width=40).text-center
                      span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                    th(width=150)
                      span(v-if="page == 'team'") {{ $t("ui.add_team_provider") }}
                      span(v-if="page == 'mapteam'") {{ $t("ui.prefer_provider") }}
                      span(v-if="page == 'purgeteam'") {{ $t("ui.input_team_id") }}
                tbody
                  tr(v-for="item in filteredNewDetailList")
                    td
                      span {{ item.team_id }}
                    td
                      span {{ getSportType(item.sport_id) }}
                    td
                      span(:title="item.team_name") {{ item.team_name }}
                    td
                      span {{ item.sbo_map }}
                    td
                      span {{ item.ibc_map }}
                    td
                      span {{ item.prefer_id }}
                    td
                      span {{ item.link_id }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                    td
                      span(v-if="page == 'team'") {{ item.add_team_provider }}
                      span(v-if="page == 'mapteam'") {{ item.prefer_provider }}
                      span(v-if="page == 'purgeteam'") {{ item.input_team_id }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    detail: {
      type: Object
    },
    page: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      recordList: [],
      sportList: []
    };
  },
  computed: {
    filteredOldDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'old';
      });
    },
    filteredNewDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'new';
      });
    },
  },
  methods: {
    getRecord() {
      let url = config.auditLogDetailRecordUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: this.detail.log_id,
        log_detail_id: this.detail.log_detail_id,
        audit_table_name: this.detail.audit_table_name
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.recordList = response.data.tbl_audit_log_detail_record;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSportType(id) {
      return this.sportList.filter((item) => {
        return item.sport_id == id;
      })[0].sport_type;
    },
    getSportList() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    shown() {
      this.getSportList();
      this.getRecord();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
